/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Welcome_HInputs */

const en_funnel_ob_welcome_h = /** @type {(inputs: Funnel_Ob_Welcome_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From [paper] to [playlist] in seconds.`)
};

const es_funnel_ob_welcome_h = /** @type {(inputs: Funnel_Ob_Welcome_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De [artículo] a [playlist] en segundos.`)
};

/**
* | output |
* | --- |
* | "From [paper] to [playlist] in seconds." |
*
* @param {Funnel_Ob_Welcome_HInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_welcome_h = /** @type {((inputs?: Funnel_Ob_Welcome_HInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Welcome_HInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_welcome_h(inputs)
	return en_funnel_ob_welcome_h(inputs)
});